import {authAxios} from "./axiosClient";
import {
        groupISMSUserURL,
} from "../constants";

export const GetGroupISMSUserApi = (params={})=>{
        return authAxios().get(groupISMSUserURL,{params})
}

// export const GetTypeQuestionApi = (params={})=>{
//         return authAxios().get(questiontypeURL,{params})
// }

// export const PostTypeQuestionApi = (params={})=>{
//         const url = questiontypeURL;
//         return authAxios().post(url, params);
// }

export const PostGroupISMSUserApi = (params={})=>{
        const url = groupISMSUserURL;
        return authAxios().post(url, params);
}
